import { useState } from "react"
import { useApiClient } from "@/api/client"
import { useWorkspace } from "@/workspaces/WorkspaceContext"

export function DemoBanner() {
  const { workspace, updateWorkspaceLocal } = useWorkspace()
  const { fetchWithAuth } = useApiClient()
  const [clearing, setClearing] = useState(false)

  if (!workspace.has_demo_data) return null

  async function handleClear() {
    if (clearing) return
    setClearing(true)
    try {
      await fetchWithAuth(`/api/workspaces/${workspace.slug}/demo/data`, { method: "DELETE" })
      updateWorkspaceLocal({ ...workspace, has_demo_data: false })
    } catch {
      // ignore
    } finally {
      setClearing(false)
    }
  }

  return (
    <div className="flex shrink-0 items-center justify-center gap-3 bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-800/60 px-4 py-2 text-xs text-amber-800 dark:text-amber-300">
      <span className="font-medium">Демо-режим:</span>
      <span className="text-amber-700 dark:text-amber-400">
        В пространстве загружены демо-данные. Они не влияют на реальную работу.
      </span>
      <button
        type="button"
        onClick={handleClear}
        disabled={clearing}
        className="ml-1 rounded-lg border border-amber-300 dark:border-amber-700 bg-white dark:bg-amber-900/30 px-2.5 py-1 font-medium text-amber-800 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-800/40 disabled:opacity-50 transition-colors"
      >
        {clearing ? "Очищаем..." : "Очистить"}
      </button>
    </div>
  )
}
